import { gql } from '@apollo/client';

export const GET_TEAM_MEMBER_TYPES = gql`
  query teamMemberTypes($ids: [ID!], $state: State) {
    teamMemberTypes(ids: $ids, state: $state) {
      id
      name
      isPL
      description
      seq
      disabled
      scopeTypes
    }
  }
`;

export const UPDATE_TEAM_MEMBER_TYPE = gql`
  mutation updateTeamMembertType($input: UpdateTeamMemberTypeInput!) {
    updateTeamMemberType(input: $input) {
      id
      name
    }
  }
`;

export const ADD_TEAM_MEMBER_TYPE = gql`
  mutation addTeamMembertType($input: AddTeamMemberTypeInput!) {
    addTeamMemberType(input: $input) {
      id
      name
    }
  }
`;

export const GET_TEAM_MEMBER_TYPE_SCOPE_TYPE = gql`
  query teamMemberTypeScopeType {
    teamMemberTypeScopeType: __type(name: "TeamMemberTypeScopeType") {
      enumValues {
        name
        description
      }
    }
  }
`;
